import { render, staticRenderFns } from "./UpdateNotificationDialog.vue?vue&type=template&id=ae026ffe&scoped=true"
import script from "./UpdateNotificationDialog.vue?vue&type=script&lang=js"
export * from "./UpdateNotificationDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateNotificationDialog.vue?vue&type=style&index=0&id=ae026ffe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae026ffe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae026ffe')) {
      api.createRecord('ae026ffe', component.options)
    } else {
      api.reload('ae026ffe', component.options)
    }
    module.hot.accept("./UpdateNotificationDialog.vue?vue&type=template&id=ae026ffe&scoped=true", function () {
      api.rerender('ae026ffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/notification/UpdateNotificationDialog.vue"
export default component.exports